export default __webpack_public_path__ + "static/media/footwork.8bdbd26a.webp";